import React from 'react'
import searchIcon from "../../asset/images/search-icon.svg"
import downloadbrokrage from '../../asset/images/download-brokrage.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate, copyTextNew, formatDate, formatDateTime, mobileVal, noDataFound, onlyNumber } from '../../CommonMethhods/CommonMethods';
import AttachmentFile from "../../asset/images/Vector.svg";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { GenerateLinkURL, Hni_Admin_Api } from '../../Configuration/API_URL';
import Loader from '../../Components/Common/Loader';
import SmallLoader from '../../Components/Common/smallLoader';
import { useDebounce } from '../../Components/useDebounce';
import contentcopy from '../../asset/images/copy-link.svg'
import LoaderForSearch from '../../Components/Common/LoaderForSearch';
import contentcopyOpt from "../../asset/images/copy-icon.svg";
import axiosInstance, { axiosMultipartInstance } from '../../CommonMethhods/axiosInstance';
import FromdateComponent from '../Reports/FromdateComponent';
import TodateComponent from '../Reports/TodateComponent';
import moment from 'moment';

const GeneralLink = ({ title }) => {
  const storeToken = localStorage.getItem("ssoToken");
  const getRole = localStorage.getItem("cosmosProjectRole");
  const [statusFilter, setStatusFilter] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [dpcData, setDpcData] = useState([]);
  const [mtfData, setMtfData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [loader, setLoader] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchField, setSerchField] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [allPackData, setAllPackData] = useState([]);
  const [actionVal, setActionVal] = useState({});
  const [remarkVal, setRemarkVal] = useState("");
  const [insertLoader, setInsertLoader] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [prefieldVal, setPrefieldVal] = useState(false);
  const [link, setLink] = useState({});
  const [amcData, setAmcData] = useState([]);
  const [linkValidityData, setLinkValidityData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorResp, setErrorResp] = useState(false);
  const navigate = useNavigate();
  const [toDateErr, setToDateErr] = useState(false);
  const [dateKey, setDateKey] = useState(0);

  const debouncedValue = useDebounce(searchInput, 1000);

  useEffect(() => {
    handleSearchChange(debouncedValue);
  }, [debouncedValue]);

  const brokerageFilter = Yup.object().shape({
    delivery: Yup.string().required("Delivery is required").typeError("typeError"),
    intraday: Yup.string().required("Intraday is required").typeError("typeError"),
    futures: Yup.string().required("Futures is required").typeError("typeError"),
    options: Yup.string().required("Options are required").typeError("typeError"),
    mtf: Yup.string().required("MTF is required"),
    dpc: Yup.string().required("DPC is required"),
    amc: Yup.string().required("AMC is required"),
    linkValidity: Yup.string().required("Link Validity is required"),

    // dpType: Yup.string().required("DP Type is required"),


    // approvalLetter: Yup.string().required("Approval letter is required"),
    approvalLetter: Yup.string()
      .when(['delivery', 'intraday', 'futures', 'options'], {
        is: (delivery, intraday, futures, options) => {
          const extractNumber = (str) => {
            const match = str?.toString().match(/[\d.]+/);
            return match ? parseFloat(match[0]) : NaN;
          };

          const deliveryNum = extractNumber(delivery);
          const intradayNum = extractNumber(intraday);
          const futuresNum = extractNumber(futures);
          const optionsNum = extractNumber(options);

          return (
            deliveryNum < 0.30 ||
            intradayNum < 0.03 ||
            futuresNum < 0.03 ||
            optionsNum < 30
          );
        },
        then: Yup.string().required("Approval letter is required").typeError("typeError"),
        otherwise: Yup.string().notRequired(),
      }),
  });

  const { register,
    handleSubmit,
    trigger,
    watch,
    formState: { errors, isValid },
    setValue,
    reset: resetForm } = useForm({
      mode: "onChange",
      resolver: yupResolver(brokerageFilter),
      defaultValues: {
        linkValidity: String(
          linkValidityData?.find(
            (item) => item?.label?.toLowerCase().trim() === "7 days"
          )?.id ?? ""
        ),
      },
    });


  const getGeneralDetails = async (value = "", type, limit, currentOffset = offset) => {
    if (type === "grid" && currentOffset > 0) {
      setLoader(false)
    }
    else if (type === "excel") {
      setSmallLoaderExcel(true);
    } else {
      setLoader(true);
    }
    let payloadValue = {
      format: type,
      search: value,
      offset: currentOffset,
      limit: limit
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getStockDetails = await axiosInstance.post(
        Hni_Admin_Api.getGeneralDetail,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getStockDetails?.data);
      if (res?.status === 0) {
        setActionVal({})
        setRemarkVal("");
        setCount(res?.data?.totalCount)
        if (type === "grid") {
          if (currentOffset > 0) {
            setFilteredData((prev) => {
              return [...prev, ...res?.data?.generalDetails];
            })
          } else {
            setTableData(res?.data?.generalDetails);
            setFilteredData(res?.data?.generalDetails);
          }
        }
        else if (type === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (type === "grid") {
          setFilteredData([])
          setTableData([])
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    } finally {
      if (type === "excel") {
        setSmallLoaderExcel(false);
      }
      else {
        setLoader(false);
        setScrollLoader(false);
      }
    }
  };

  useEffect(() => {
    getGeneralDetails(searchInput, "grid", 5, offset);
  }, [offset]);

  const getDpcListData = async () => {
    let payloadValue = {
      offset: 0,
      limit: -1
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDpc = await axiosInstance.post(
        Hni_Admin_Api.getDpcList,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getDpc?.data);
      if (res?.status === 0) {
        setDpcData(res?.data?.dpcList);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const getMtfListData = async () => {
    let payloadValue = {
      offset: 0,
      limit: -1
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getMtf = await axiosInstance.post(
        Hni_Admin_Api.getMtfList,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getMtf?.data);
      if (res?.status === 0) {
        setMtfData(res?.data?.mtfList);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const getAmcListData = async () => {
    let payloadValue = {
      offset: 0,
      limit: -1
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDpc = await axiosInstance.post(
        Hni_Admin_Api.getAmcList,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getDpc?.data);
      if (res?.status === 0) {
        setAmcData(res?.data?.amcList);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const getAllPackDetails = async () => {
    try {
      const getPackData = await axiosInstance.get(
        Hni_Admin_Api.getPackDetails,

      );

      const res = ApiResDecrypt(getPackData?.data);
      if (res?.status === 0) {
        setAllPackData(res?.data);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const getLinkValidityData = async () => {
    try {
      const getPackData = await axiosInstance.get(
        Hni_Admin_Api.getLinkValidity,

      );

      const res = ApiResDecrypt(getPackData?.data);
      if (res?.status === 0) {
        setLinkValidityData(res?.data);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    if (getRole === "RM" || getRole === "Franchise") {
      getAllPackDetails();
      getDpcListData();
      getMtfListData();
      getAmcListData();
      getLinkValidityData();
    }
  }, []);

  const sevenDaysOption = linkValidityData?.find(
    (item) => item?.label?.toLowerCase().trim() === "7 days"
  );
  
    useEffect(() => {
    if (sevenDaysOption) {
      setValue("linkValidity", String(sevenDaysOption.id), {
        shouldValidate: true,
      });
    }
  }, [linkValidityData, setValue]);

   function formatStartDate(date) {
      return moment(date).format("YYYY-MM-DDTHH:mm:ssZ");
  }
  
  function formatEndDate(date) {
      return moment(date)
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ssZ");
  }

  const insertGeneralTableData = async (data) => {
    setInsertLoader(true);

    const extractNumber = (str) => {
      const match = str?.toString().match(/[\d.]+/);
      return match ? parseFloat(match[0]) : NaN;
    };

    const deliveryNum = extractNumber(data?.delivery);
    const intradayNum = extractNumber(data?.intraday);
    const futuresNum = extractNumber(data?.futures);
    const optionsNum = extractNumber(data?.options);

    const isApprovalRequired = (
      deliveryNum < 0.30 ||
      intradayNum < 0.03 ||
      futuresNum < 0.03 ||
      optionsNum < 30
    );

    let payload = {
      delivery: data?.delivery,
      intraday: data?.intraday,
      futures: data?.futures,
      options: data?.options,
      mtf: parseInt(data?.mtf),
      dpc: parseInt(data?.dpc),
      amc: data?.amc,
      tokenValidityId: data?.linkValidity,
      ...(data?.linkValidity === "8" && {
        customStartDate: formatStartDate(fromDate),
        customEndDate: formatEndDate(toDate)
    }),
      // dpType: data?.dpType,
      // approvalLetter: data?.approvalLetter
      // approvalLetter: fileUrl
      ...(isApprovalRequired && { approvalLetter: fileUrl })
    }
    let encPayload = AESEncryption(payload);
    try {
      const getData = await axiosInstance.post(
        Hni_Admin_Api.insertGeneralDetail,
        `"${encPayload}"`,

      );
      const res = ApiResDecrypt(getData?.data);
      if (res?.status === 0) {
        toast.success("Brokerage details saved successfully!");
        getGeneralDetails("", "grid", 5, 0);
        resetButton();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    } finally {
      setInsertLoader(false);
    }
  };

  const expireLink = async (item) => {
      let payloadValue = {
        rmCode: item?.rmCode,
        id: item?.id,
      };
      let encPayload = AESEncryption(payloadValue);
      try {
        const getRemark = await axiosInstance.post(
          Hni_Admin_Api.expireGeneralLink,
          `"${encPayload}"`,
  
        );
        const res = ApiResDecrypt(getRemark?.data);
        console.log(res, "expireRes");
        if (res?.status === 0) {
          getGeneralDetails("", "grid", 5, 0);
          toast.success(res?.data);
        } else {
          toast.error(res?.message)
        }
      } catch (error) {
        if (error?.request?.status == 401) {
          localStorage.clear("");
          navigate("/");
        }
      }
    };

  const updateRemarksData = async (item) => {
    let payloadValue = {
      id: item?.id,
      remarks: remarkVal,
      status: actionVal[item?.id]
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRemark = await axiosInstance.put(
        Hni_Admin_Api.updateGeneralRemarks,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getRemark?.data);
      if (res?.status === 0) {
        toast.success(res?.data);
        getGeneralDetails("", "grid", 5, 0);
        setActionVal({})
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const uploadOnAwsApi = async (file, fileType) => {
    try {
      const formData = new FormData();
      formData.append("fileData", file[0]);

      const declarationData = await axiosMultipartInstance.post(
        Hni_Admin_Api.uploadDocOnAwsFile,
        formData,
      );
      const res = declarationData?.data;
      console.log(res, "resdoc");
      
      if (res?.status === 0) {
        setFileUrl(res?.data?.fileName);
        setValue(fileType, res?.data?.fileName, {
        shouldValidate: true,
        shouldDirty: true,
      });

      trigger(fileType);
      } else {
        setValue(fileType, "");
      setFileUrl("");
        toast.error(res?.message);
      }
    } catch (error) {
      setValue(fileType, "");
      setFileUrl("");
      toast.error(error?.message);
    } finally {
      // setUploadGstLoader(false);
    }
  };

  const updateGeneralDetailData = async (data) => {

    const extractNumber = (str) => {
      const match = str?.toString().match(/[\d.]+/);
      return match ? parseFloat(match[0]) : NaN;
    };

    const deliveryNum = extractNumber(data?.delivery);
    const intradayNum = extractNumber(data?.intraday);
    const futuresNum = extractNumber(data?.futures);
    const optionsNum = extractNumber(data?.options);

    const isApprovalRequired = (
      deliveryNum < 0.30 ||
      intradayNum < 0.03 ||
      futuresNum < 0.03 ||
      optionsNum < 30
    );

    let payloadValue = {
      id: data?.id,
      delivery: data?.delivery,
      intraday: data?.intraday,
      futures: data?.futures,
      options: data?.options,
      mtf: data?.mtf,
      dpc: data?.dpc,
      amc: data?.amc,
      approvalLetter: data?.approvalLetter || "",
      tokenValidityId: data?.linkValidity,
      ...(String(data?.linkValidity) === "8" && {
      customStartDate: formatStartDate(fromDate),
      customEndDate: formatEndDate(toDate),
      customeTokenValidity: null,
    }),
      // dpType: data?.dpType,
      // approvalLetter: data?.approvalLetter
      // ...(isApprovalRequired && { approvalLetter: data?.approvalLetterapprovalLetter: data?.approvalLetter })
    };

    console.log(payloadValue, "payloadValueUpdate");
    
    let encPayload = AESEncryption(payloadValue);
    try {
      const getUpdatedRes = await axiosInstance.put(
        Hni_Admin_Api.updateGeneralDetails,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getUpdatedRes?.data);
      if (res?.status === 0) {
        toast.success(res?.data);
        getGeneralDetails("", "grid", 5, 0);
        resetButton();
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  function resetButton() {
    resetForm({
      delivery: "",
      intraday: "",
      futures: "",
      options: "",
      mtf: "",
      dpc: "",
      amc: "",
      linkValidity: String(
        linkValidityData?.find(
          (item) => item?.label?.toLowerCase().trim() === "7 days"
        )?.id ?? ""
      ),
      // dpType: "",
      approvalLetter: ""
    })
    setFromDate("")
    setToDate("")
    setPrefieldVal(false);
  }

  const handleFilterChange = (status) => {
    setStatusFilter(status);
    if (status === '') {
      setFilteredData(tableData);
    }
    else {
      const filtered = tableData.filter(item => item?.status === status);
      setFilteredData(filtered);
    }
  };

  const generateHniLink = async (item) => {
    let payloadValue = {
      rmCode: item?.rmCode,
      id: item?.id,
      // dpType: item?.dpType
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");

    try {
      const getRemark = await axiosInstance.post(
        Hni_Admin_Api.generateGeneralLink,
        `"${encPayload}"`,

      );
      const res = ApiResDecrypt(getRemark?.data);
      console.log(res, "res888");

      if (res?.status === 0) {
        setLink((prevLinks) => ({
          ...prevLinks,
          [item?.id]: res?.data,
        }));
      } else {
        toast.error(res?.message)
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (count != filteredData.length) {
        setScrollLoader(true);
        setOffset((prev) => prev + 1);
        setLoader(false);
      }
    }
  };
  const handleDownloadBtn = () => {
    getGeneralDetails(searchInput, "excel", -1, 0)
  }

  function editTable(data) {

    console.log(data, "dataedit");
    
    const extractNumber = (str) => {
      const match = str?.toString().match(/[\d.]+/);
      return match ? parseFloat(match[0]) : NaN;
    };

    const deliveryNum = extractNumber(data?.delivery);
    const intradayNum = extractNumber(data?.intraday);
    const futuresNum = extractNumber(data?.futures);
    const optionsNum = extractNumber(data?.options);

    const isApprovalRequired = (
      deliveryNum < 0.30 ||
      intradayNum < 0.03 ||
      futuresNum < 0.03 ||
      optionsNum < 30
    );

    resetForm({
      id: data?.id,
      delivery: data?.delivery,
      intraday: data?.intraday,
      futures: data?.futures,
      options: data?.options,
      mtf: data?.mtf,
      dpc: data?.dpc,
      amc: data?.amc,
      linkValidity: String(data?.tokenValidityId ?? ""),
      status: data?.status,
      remarks: data?.remarks,
      ...(isApprovalRequired && {
        approvalLetter: data?.approvalLetterName || fileUrl
      })
    })
  const startDate = data?.customStartDate?.split("T")[0] || "";
  const endDate = data?.customEndDate?.split("T")[0] || "";

  console.log("Formatted start date:", startDate);
  console.log("Formatted end date:", endDate);

  setFromDate(startDate);
  setToDate(endDate);
  setDateKey((prev) => prev + 1);

    setPrefieldVal(true);
  }

  const handleSearchChange = (data) => {
    if (data) {
      getGeneralDetails(data, "grid", 5, 0);
    }
    else if (searchField === true) {
      getGeneralDetails("", "grid", 5, 0);
      // setFilteredData([])
    }
    setOffset(0);
  };


  // const handleFileUpload = (e, fileType) => {
  //   const MAX_FILE_SIZE = 1048576 * 5;
  //   const file = e?.target?.files?.[0];
  //   if (!file) return;
  //   if (file.size > MAX_FILE_SIZE) {
  //     setValue(fileType, "");
  //     toast.error("Please select a file less than 5MB");
  //     return;
  //   }
  //   uploadOnAwsApi(e?.target?.files, fileType);
  //   setValue(fileType, file?.name, { shouldValidate: true });
  //   trigger(fileType);
  // };

  
const handleFileUpload = async (e, fileType) => {
  const MAX_FILE_SIZE = 1048576 * 5;
  const file = e?.target?.files?.[0];

  if (!file) return;

  if (file.size > MAX_FILE_SIZE) {
    setValue(fileType, "");
    e.target.value = "";
    toast.error("Please select a file less than 5MB");
    return;
  }

  setValue(fileType, "");
  setFileUrl("");

  await uploadOnAwsApi(e.target.files, fileType, file.name);
};


  const onSubmit = (data) => {
    if (prefieldVal === true) {
      updateGeneralDetailData(data);
    } else if (durationVal === "8") {
      const today = moment().startOf("day");
      const checkFromDate = moment(fromDate, "MM-DD-YYYY", true);
      const checkToDate = moment(toDate, "MM-DD-YYYY", true);
  
      if (!checkFromDate.isValid() || checkFromDate.isAfter(today)) {
        setErrorResp("From Date cannot be in the future");
        return;
      }
  
      if (!checkToDate.isValid() || checkToDate.isBefore(today)) {
        setToDateErr("To Date cannot be earlier than today");
        return;
      }
  
      if (checkFromDate.isAfter(checkToDate)) {
        setErrorResp("Please Select Correct Date");
        return;
      }
  
      insertGeneralTableData(data);
      setErrorResp(false);
      setToDateErr(false);
    } else {
      insertGeneralTableData(data);
    }
  };

  const handleAction = (val, id) => {
    setActionVal(prevState => ({
      ...prevState,
      [id]: val
    }));
  }

  const handleRemark = (e) => {
    setRemarkVal(e?.target?.value)
  }

  const handleSubmitRemark = (item) => {
    updateRemarksData(item)
  }

  const ascendingOrder = (column) => {
    const sortedList = [...filteredData].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return a[column].localeCompare(b[column] || "");
      } else {
        return a[column] - b[column];
      }
    });

    setFilteredData(sortedList);
  };

  const descendingOrder = (column) => {
    const sortedList = [...filteredData].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return b[column].localeCompare(a[column] || "");
      } else {
        return b[column] - a[column];
      }
    });
    setFilteredData(sortedList);
  };

  const extractNumber = (str) => {
    const match = str?.match(/[\d.]+/);
    return match ? parseFloat(match[0]) : NaN;
  };

   const handleFromDateChange = (e) => {
      let c = e.target.value;
      if (c && c > new Date().toLocaleDateString("en-CA")) {
      setErrorResp("From Date cannot be in the future");
      return;
    }
      const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
      setFromDate(d);
      setErrorResp(false);
    };

    const handleToDateChange = (e) => {
      let c = e.target.value;
  
      if (c && c < new Date().toLocaleDateString("en-CA")) {
      setToDateErr("To Date cannot be earlier than today");
      return;
    }
      
      const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
      setToDate(d);
      setToDateErr(false);
    };

  const intradayVal = watch("intraday");
  const deliveryVal = watch("delivery");
  const futuresVal = watch("futures");
  const optionsVal = watch("options");
  const durationVal = watch("linkValidity");

  const intradayNumeric = extractNumber(intradayVal);
  const deliveryNumeric = extractNumber(deliveryVal);
  const futureNumeric = extractNumber(futuresVal);
  const optionNumeric = extractNumber(optionsVal);


  const showUploadSection =
    intradayNumeric < 0.03 ||
    deliveryNumeric < 0.30 ||
    futureNumeric < 0.03 ||
    optionNumeric < 30;

  const [hniLink, setHniLink] = useState("");

  const copyToClipboard = (hniLink) => {
    if (!hniLink) return;


    // if (hniLink) {
    try {
      const urlObj = new URL(hniLink);
      const baseUrl = urlObj.origin;

      if (baseUrl === GenerateLinkURL) {
        navigator.clipboard.writeText(hniLink)
          .then(() => {
            toast.success("Link copied to clipboard");
          })
          .catch(err => {
            toast.error("Failed to copy text: " + err);
          });
      } else {
        toast.warning("Invalid link base URL!");
      }
    } catch (error) {
      console.error("Invalid URL format:", error);
      toast.error(hniLink);
    }


  };

  const gethniekyclink = async () => {
    // const payload = {
    //   dpType: type
    // }
    // let encPayload = AESEncryption(payload);

    try {
      const gethniekyclinkDetails = await axiosInstance.get(
        Hni_Admin_Api.gethniekyclink,
        // `"${encPayload}"`,


      );

      const res = ApiResDecrypt(gethniekyclinkDetails?.data);
      console.log(res, "checkLink");

      if (res?.status === 0) {
        // toast.success(res?.message)
        setHniLink(res.data)
        copyToClipboard(res.data);
      } else {
        toast.error(res?.message)
        // setHniLink(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const getExpiryDate = () => {
  if (!durationVal) {
    return "";
  }

  if (durationVal === "8") {
    return toDate ? formatDate(toDate) : "";
  }

  const selectedDuration = linkValidityData?.find(
    (item) => String(item?.id) === String(durationVal)
  );

  const label = selectedDuration?.label;

  if (!label) {
    return "";
  }

  const expiryDate = moment();

  switch (label) {
    case "24 Hours":
      expiryDate.add(24, "hours");
      break;

    case "3 Days":
      expiryDate.add(3, "days");
      break;

    case "7 Days":
      expiryDate.add(7, "days");
      break;

    case "15 Days":
      expiryDate.add(15, "days");
      break;

    case "30 Days":
      expiryDate.add(30, "days");
      break;

    case "1 Month":
      expiryDate.add(1, "month");
      break;

    case "3 Months":
      expiryDate.add(3, "months");
      break;

    default:
      return "";
  }

  return expiryDate.format("DD MMM YYYY");
};

  const isDateMissing = durationVal === "8" && (!fromDate || !toDate);

  console.log(filteredData, "filteredData");


  return (
    <>
      {getRole === "Admin" || getRole === "BranchAdmin" || getRole === "RegionalHead" || getRole === "ZonalHead" || getRole === "BusinessHead" ?
        <div className='personal-page brokerage'>

          <div className='personal-wrapper'>
            <div className="personal-buttons-wrapper">
              <button
                type="button"
                className={`${statusFilter === "Pending" ? "selected-button" : "personal-buttons"}`}
                onClick={() => handleFilterChange('Pending')}
              // disabled={getRole !== "Admin"}
              >
                Pending
              </button>

              <button
                type="button"
                className={`${statusFilter === "Approved" ? "selected-button" : "personal-buttons"}`}
                onClick={() => handleFilterChange('Approved')}
              // disabled={getRole !== "Admin"}
              >
                Approved
              </button>

              <button
                type="button"
                className={`${statusFilter === "Rejected" ? "selected-button" : "personal-buttons"}`}
                onClick={() => handleFilterChange('Rejected')}
              // disabled={getRole !== "Admin"}
              >
                Rejected
              </button>
            </div>


          </div>
          {filteredData?.length > 0 ? <>
            <div className='personal-wrapper'>
              <div className='search-input-wrapper'>
                <div className="rm-custom-dropdown">
                  <img src={searchIcon} alt="search" />

                  <input
                    type="text"
                    name="search-text"
                    className="input-st ap"
                    value={searchInput}
                    onInput={onlyNumber}
                    maxLength={6}
                    placeholder="Search by RM code"
                    autoComplete="off"
                    onPaste={(e) => {
                      e.preventDefault();
                      const paste = e.clipboardData.getData("text");
                      const numbersOnly = paste.replace(/\D/g, "");
                      const finalValue = numbersOnly.slice(0, 6);
                      e.target.value = finalValue;
                    }}
                    onChange={(e) => {
                      setSearchInput(e?.target?.value?.toLowerCase());
                      setSerchField(true)
                    }}
                  />

                </div>

                <button className="dnload-btn" onClick={handleDownloadBtn}>
                  {smallLoaderExcel ? (
                    <SmallLoader />
                  ) :
                    <>
                      <img src={downloadbrokrage} alt="download" />
                      Download All</>
                  }
                </button>
              </div>
            </div>
            <div className='brokerage-table'>
              {loader ? (
                <Loader />
              ) :
                <div className="scroll-table master_table personalised-table general-table">
                  {filteredData?.length > 0 && filteredData.filter(item => {
                    const intraday = extractNumber(item?.intraday || 0);
                    const delivery = extractNumber(item?.delivery || 0);
                    const futures = extractNumber(item?.futures || 0);
                    const options = extractNumber(item?.options || 0);

                    if (getRole === "BranchAdmin" || getRole === "RegionalHead") {
                      return (
                        intraday > 0.02 && intraday < 0.03 &&
                        delivery > 0.20 && delivery < 0.30 &&
                        futures > 0.02 && futures < 0.03 &&
                        options > 20 && options < 30
                      );
                    }
                    else if (getRole === "ZonalHead") {
                      return (
                        intraday >= 0.01 && intraday <= 0.02 &&
                        delivery >= 0.10 && delivery <= 0.20 &&
                        futures >= 0.01 && futures <= 0.02 &&
                        options >= 10 && options <= 20
                      );
                    }
                    else if (getRole === "BusinessHead") {
                      return (
                        intraday <= 0.01 &&
                        delivery <= 0.10 &&
                        futures <= 0.01 &&
                        options <= 10
                      );
                    }
                    else if (getRole === "Admin") {
                      return true
                    }
                  }) ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            <span className='wrap-th'>
                              <span>Sr. No</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>RM Code</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("rmCode")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("rmCode")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>RM Name</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("rmName")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("rmName")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Delivery</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("delivery")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("delivery")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Intraday</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("intraday")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("intraday")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Futures</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("futures")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("futures")}
                                ></span>
                              </span>
                            </span></th>
                          <th><span className='wrap-th'>
                            <span>Options</span>
                            <span className='wrap-icons'>
                              <span
                                className="icon-up-triangle"
                                onClick={() => descendingOrder("options")}
                              ></span>
                              <span
                                className="icon-down-triangle"
                                onClick={() => ascendingOrder("options")}
                              ></span>
                            </span>
                          </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>DPC</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("dpc")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("dpc")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>AMC</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("amc")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("amc")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          
                          {/* <th>
                            <span className='wrap-th'>
                              <span>DP Type</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("dpType")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("dpType")}
                                ></span>
                              </span>
                            </span>
                          </th> */}
                          <th>
                            <span className='wrap-th'>
                              <span>MTF</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("mtf")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("mtf")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Created Date</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("createdDate")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("createdDate")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Approval Letter</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Status</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("status")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("status")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Actions</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Remarks</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Confirm Action</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Link Validity</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("linkValidity")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("linkValidity")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Deactivate Link</span>
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody onScroll={(e) => handleScroll(e)} id="per-table-body">
                        {filteredData?.length > 0 && filteredData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.rmCode || "-"}</td>
                            <td>{item?.rmName || "-"}</td>
                            <td>₹{item?.delivery || "-"}</td>
                            <td>₹{item?.intraday || "-"}</td>
                            <td>₹{item?.futures || "-"}</td>
                            <td>₹{item?.options || "-"}</td>
                            <td>{item?.dpc || 0}%</td>
                            <td>{item?.amc || 0}%</td>
                            {/* <td>{item?.dpType}</td> */}
                            <td>{item?.mtf}%</td>
                            <td>{formatDate(item?.createdDate) || "-"}</td>
                            <td className='text-blue-dark' style={{ cursor: "pointer" }}>
                              <div className='d-flex align-items-center'>
                                <div
                                  onClick={() => {
                                    window.open(
                                      item?.approvalLetter,
                                      "_blank",
                                      "noopener,noreferrer"
                                    );
                                  }}
                                  className="tagAnchor"
                                >
                                  {item?.approvalLetterName}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className={`status-label ${item?.status === 'Pending' ? 'text-yellow' :
                                item?.status === 'Approved' ? 'text-green bg-light-green-new' : 'txt-red bg-light-red-new'}`}>
                                {item?.status}
                              </div>
                            </td>
                            <td>
                              <div className='action-wrapper'>
                                <button
                                  className={`${(actionVal[item?.id] === "Approved" || item?.status == "Approved") ?
                                    "text-white bg-green status-label no-drop-cursor" :
                                    item?.status === "Rejected" || item?.status === "Expired" ? "disabled-text-approve status-label no-drop-cursor" :
                                      "disabled-text-approve status-label"}`}
                                  type='button'
                                  onClick={() => handleAction("Approved", item?.id)}
                                >
                                  Approve
                                </button>

                                <button
                                  className={`${actionVal[item?.id] === "Rejected" || item?.status === "Rejected" ?
                                    "text-white bg-red status-label no-drop-cursor" :
                                    item?.status === "Approved" || item?.status === "Expired" ? "disabled-text-reject status-label no-drop-cursor" :
                                      "disabled-text-reject status-label"}`}
                                  type='button'
                                  onClick={() => handleAction("Rejected", item?.id)}
                                >
                                  Reject
                                </button>
                              </div>
                            </td>

                            <td>
                              <input
                                className={`${!actionVal[item?.id] ? "disable-remark" : 'remark-input'}`}
                                type='text'
                                placeholder='Add Remarks'
                                onChange={(e) => handleRemark(e)}
                                onInput={(e) =>
                                  (e.target.value = e.target.value.replace(/^\s+/, "").toUpperCase())
                                }
                                disabled={!actionVal[item?.id]}
                              />
                              {actionVal[item?.id] === "Rejected" &&
                                <span className="star_text">*</span>
                              }
                            </td>

                            <td>
                              <button
                                type="button"
                                className="submit-buttons"
                                onClick={() => handleSubmitRemark(item)}
                                disabled={(item?.status === "Pending" && remarkVal?.length == 0 && actionVal[item?.id] !== "Approved")
                                  || item?.status === "Rejected" || item?.status === "Approved" || item?.status === "Expired"}
                              >
                                Submit
                              </button>
                            </td>

                            {/* <td>{item?.tokenValidityId === 8 && formatDateTime(item?.customEndDate) || "-"}</td> */}
                            <td>{item?.tokenValidityId === 8 ? formatDateTime(item?.customEndDate) : item?.tokenValidity || "-"}</td>

                            <td>
                              <button
                                type="button"
                                className="deactivate-button"
                                onClick={() => expireLink(item)}
                                disabled={item?.status !== "Approved"}
                              >
                                Deactivate
                              </button>
                            </td>
                          </tr>
                        ))
                        }
                      </tbody>
                    </table>
                  ) : noDataFound()
                  }
                </div>
              }
            </div>
          </>
            :
            <div className='nodata-card'>
              {noDataFound()}
            </div>
          }
        </div>
        :
        getRole === "RM" || getRole === "Franchise" ?
          <div className='personal-page brokerage'>
            <div className='copy-hni-link'>

              <div>
                <button
                  className='d-flex align-items-center'
                  style={{ background: "transparent", columnGap: "0.4rem", border: "1px solid #e8e8e8", padding: "1rem 1.6rem" }}
                  onClick={gethniekyclink}
                >
                  <img src={contentcopyOpt} alt="contentcopy" />
                  Copy HNI e-KYC Link
                </button>
              </div>

            </div>
            <div className="form-label brokerage-title custom-title">
              Select Brokerage
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>


              <div className='row input-field-wrapper'>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">Delivery
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.delivery && errors?.delivery?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("delivery")}
                    >
                      <option value="">Select Delivery</option>
                      {allPackData?.delivery?.length > 0 && allPackData?.delivery?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                    {
                      errors?.delivery && errors?.delivery?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.delivery?.message}
                      </p>
                    }
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">Intraday
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                  ${errors?.intraday && errors?.intraday?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("intraday")}
                    >
                      <option value="">Select Intraday</option>
                      {allPackData?.intraday?.length > 0 && allPackData?.intraday?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                    {
                      errors?.intraday && errors?.intraday?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.intraday?.message}
                      </p>
                    }
                  </div>
                </div>

                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">Futures
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.futures && errors?.futures?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("futures")}
                    >
                      <option value="">Select Futures</option>
                      {allPackData?.futures?.length > 0 && allPackData?.futures?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                    {
                      errors?.futures && errors?.futures?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.futures?.message}
                      </p>
                    }
                  </div>
                </div>

                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">Options (per lot)
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.options && errors?.options?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("options")}
                    >
                      <option value="">Select Options</option>
                      {allPackData?.options?.length > 0 && allPackData?.options?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                    {
                      errors?.options && errors?.options?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.options?.message}
                      </p>
                    }
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">MTF
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                  ${errors?.mtf && errors?.mtf?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("mtf")}
                    >
                      <option value="">Select MTF</option>
                      {mtfData?.length > 0 && mtfData?.map((item) => (
                        <option value={item?.perc}>{item?.perc}%</option>
                      ))}
                    </select>
                    {
                      errors?.mtf && errors?.mtf?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.mtf?.message}
                      </p>
                    }
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">DPC
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.dpc && errors?.dpc?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("dpc")}
                    >
                      <option value="">Select DPC</option>
                      {dpcData?.length > 0 && dpcData?.map((item) => (
                        <option value={item?.perc}>{item?.perc}%</option>
                      ))}

                    </select>
                    {
                      errors?.dpc && errors?.dpc?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.dpc?.message}
                      </p>
                    }
                  </div>
                </div>

                {showUploadSection && (
                  <div className="col-md-3 col-sm-3 col-6">
                    <div className="form-group">
                      <label className="form-label">
                        Upload Approval Letter
                        <span className="star_text">*</span>
                      </label>
                      <div className="custom-upload">
                        <input
                        readOnly
                          className="f-input input-st ap upload-doc"
                          placeholder="Upload File"
                          {...register('approvalLetter')}

                        />
                        <div className="fileUpload btn btn--browse upload-doc">
                          <img
                            src={AttachmentFile}
                            alt="attachment"
                            className
                          />
                          <span>Browse File</span>
                          <input
                            type="file"
                            className="upload"
                            accept=".pdf,.png,.jpg,.jpeg"
                            onChange={(e) => { handleFileUpload(e, "approvalLetter") }}

                          />
                        </div>
                      </div>
                      <div className="ErrorMsg">
                        {/* {errors.inputFileGst?.message} */}
                      </div>
                      <span className="limit-text">
                        File format: png, jpg, jpeg & pdf. Maximum file size: 5 MB
                      </span>
                    </div>
                  </div>
                )}

                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">AMC
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.amc && errors?.amc?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("amc")}
                    >
                      <option value="">Select AMC</option>
                      {amcData?.length > 0 && amcData?.map((item) => (
                        <option value={item?.val}>{item?.val}%</option>
                      ))}

                    </select>
                    {
                      errors?.amc && errors?.amc?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.amc?.message}
                      </p>
                    }
                  </div>
                </div>

              </div>

              <div className='row input-field-wrapper mt-4'>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">Link Validity
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.linkValidity && errors?.linkValidity?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("linkValidity", {
                        onChange: () => {setErrorResp(""); setToDateErr("")},
                      })}
                    >
                      <option value="">Select Link Validity</option>
                      {linkValidityData?.length > 0 && linkValidityData?.map((item) => (
                        <option value={item?.id}>{item?.label}</option>
                      ))}

                    </select>
                    {
                      errors?.linkValidity && errors?.linkValidity?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.linkValidity?.message}
                      </p>
                    }

                    {durationVal && durationVal !== "8" && !prefieldVal && (
                      <span className='expiry-text'>Expires on {getExpiryDate()}</span>
                  )}
                  </div>

                  
                </div>

                {durationVal === "8" && <div className="col-md-3 col-sm-3 col-6">
                  <FromdateComponent
                  key={`from-${dateKey}`}
                    fromDate={handleFromDateChange}
                    formatDate={fromDate}
                    DateReverse={DateReverse}
                    errorResponse={errorResp}
                    clientWiseReportForCustomCalanderIcon={false}
                    inputWidth={"custom"}
                  />
                </div>}

                {durationVal === "8" && <div className="col-md-3  col-sm-3 col-6">
                  <TodateComponent
                  key={`to-${dateKey}`}
                    toDate={handleToDateChange}
                    formatToDate={toDate}
                    DateReverse={DateReverse}
                    errorResponse={toDateErr}
                    clientWiseReportForCustomCalanderIcon={false}
                    inputWidth={"custom"}
                    minDate={new Date().toISOString().split("T")[0]}
                    allowFutureDates={true}
                  />

                </div>}
              </div>

              <div className="brokerage-btn-section">
                <button type="submit"
                  className={`${!isValid || isDateMissing ? "personalise-btn-disabled" : "brokerage-save-btn"}`}
                  disabled={!isValid || isDateMissing} >
                  {insertLoader ?
                    <SmallLoader />
                    :
                    <>Generate Link</>
                  }
                </button>
              </div>
            </form>
            <div className='personal-wrapper'>
              <div className='search-input-wrapper'>
                <button className="dnload-btn" onClick={handleDownloadBtn}>
                  {smallLoaderExcel ? (
                    <SmallLoader />
                  ) :
                    <>
                      <img src={downloadbrokrage} alt="download" />
                      Download All</>
                  }
                </button>
              </div>
            </div>

            <div className='brokerage-table'>
              {loader ? (
                <Loader />
              ) :
                <div className="scroll-table master_table personalised-table">
                  {filteredData && filteredData?.length > 0 ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            <span className='wrap-th'>
                              <span>Sr. No</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Delivery</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("delivery")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("delivery")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Intraday</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("intraday")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("intraday")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Futures</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("futures")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("futures")}
                                ></span>
                              </span>
                            </span></th>
                          <th><span className='wrap-th'>
                            <span>Options</span>
                            <span className='wrap-icons'>
                              <span
                                className="icon-up-triangle"
                                onClick={() => descendingOrder("options")}
                              ></span>
                              <span
                                className="icon-down-triangle"
                                onClick={() => ascendingOrder("options")}
                              ></span>
                            </span>
                          </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>DPC</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("dpc")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("dpc")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>AMC</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("amc")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("amc")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Link Validity</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("linkValidity")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("linkValidity")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          {/* <th>
                            <span className='wrap-th'>
                              <span>DP Type</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("dpType")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("dpType")}
                                ></span>
                              </span>
                            </span>
                          </th> */}
                          <th>
                            <span className='wrap-th'>
                              <span>MTF</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("mtf")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("mtf")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Created Date</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("createdDate")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("createdDate")}
                                ></span>
                              </span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Approval Letter</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Status</span>
                              <span className='wrap-icons'>
                                <span
                                  className="icon-up-triangle"
                                  onClick={() => descendingOrder("status")}
                                ></span>
                                <span
                                  className="icon-down-triangle"
                                  onClick={() => ascendingOrder("status")}
                                ></span>
                              </span>
                            </span>
                          </th>

                          <th>
                            <span className='wrap-th'>
                              <span>Remarks</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Edit Details</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Generate Link</span>
                            </span>
                          </th>
                          <th>
                            <span className='wrap-th'>
                              <span>Copy Link</span>
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody onScroll={(e) => handleScroll(e)} id="per-table-body">
                        {filteredData?.length > 0 && filteredData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.delivery || "-"}</td>
                            <td>{item?.intraday || "-"}</td>
                            <td>{item?.futures || "-"}</td>
                            <td>{item?.options || "-"}</td>
                            <td>{item?.dpc || 0}</td>
                            <td>{item?.amc || 0}</td>
                            <td>{item?.tokenValidity || "-"}</td>
                            {/* <td>{item?.dpType}</td> */}
                            <td>{item?.mtf}</td>
                            <td>{formatDate(item.createdDate) || "-"}</td>
                            <td className='text-blue-dark' style={{ cursor: "pointer" }}>
                              <div className='d-flex align-items-center'>
                                <div
                                  onClick={() => {
                                    window.open(
                                      item?.approvalLetter,
                                      "_blank",
                                      "noopener,noreferrer"
                                    );
                                  }}
                                  className="tagAnchor"
                                >
                                  {item?.approvalLetterName}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className={`status-label ${item?.status === 'Pending' ? 'text-yellow' :
                                item?.status === 'Approved' ? 'text-green bg-light-green-new' : 'txt-red bg-light-red-new'}`}>
                                {item?.status}
                              </div>
                            </td>
                            <td>
                              {item?.remarks || "-"}
                            </td>
                            <td>
                              <button
                                onClick={() => editTable(item)}
                                type="button"
                                className={`${item?.status !== "Rejected" ? "disable-submit-btn" : "submit-buttons"}`}
                                disabled={item?.status !== "Rejected"}
                              >
                                Edit Details
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className={`${item?.status !== "Approved" ? "disable-submit-btn" : "submit-buttons"}`}
                                disabled={item?.status !== "Approved"}
                                onClick={() => generateHniLink(item)}
                              >
                                {link[item?.id] ? "Generated" : "Generate Link"}
                              </button>
                            </td>
                            <td className='general-td'>
                              <button
                                type="button"
                                className={`${item?.status !== "Approved" || !link[item?.id] ? "copy-btn" : "copy-btn"}`}
                                disabled={item?.status !== "Approved" || !link[item?.id]}
                                id={'modifyreqest' + index}
                                onClick={(e) => copyTextNew(e, '#modifyreqest' + index, 'modifytested' + index, link[item?.id])}
                                data-toggle="tooltip"
                                data-placement="top"
                              >
                                <span id={'modifytested' + index} className="copy-txt">
                                  {link[item?.id]}
                                </span>
                                <span >
                                  <img src={contentcopy} alt="contentcopy" height={"13"} width={"13px"} />
                                  Copy Link
                                </span>
                              </button>
                            </td>
                          </tr>
                        ))
                        }
                        {scrollLoader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </tbody>
                    </table>
                  ) : noDataFound()
                  }
                </div>
              }
            </div>
          </div>
          :
          <div className='brokerage-table'>
            {noDataFound()}
          </div>
      }
    </>
  )
}

export default GeneralLink;